module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.10782/images/certifications-card-thumbnail.webp"